import { HideImageOutlined } from "@mui/icons-material";
import { Box, SxProps, Theme } from "@mui/material";
import { useState } from "react";

interface MediaThumbnailProps {
  src?: string | null;
  alt?: string;
  sx?: SxProps<Theme>;
}

export default function MediaThumbnail({ src, alt = "", sx }: MediaThumbnailProps) {
  const [errored, setErrored] = useState(false);

  if (!src || errored) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#F5F5F5",
          color: "#9E9E9E",
          borderRadius: 1,
          ...sx,
        }}
      >
        <HideImageOutlined />
      </Box>
    );
  }

  return <Box component="img" src={src} alt={alt} onError={() => setErrored(true)} sx={sx} />;
}
